import { Box, List, ListItem, SimpleGrid } from '@chakra-ui/react';
import { useSession } from 'next-auth/react';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

import { ProductCard } from '@/components/Card/ProductCard';
import { ProductCardUnlogged } from '@/components/Card/ProductCartUnlogged';

import { Product } from '@/models/api';
import { ProductListProps } from '@/models/props/ProductListProps';
import { AppService } from '@/services';

export const ProductList = (props: ProductListProps) => {
    const { items } = props;
    const session = useSession();
    const intl = useIntl();

    useEffect(() => {
        const currency = AppService.getInstanceCurrency();
        const brand = intl.formatMessage({
            id: `data-layer.brand.${process.env.NEXT_PUBLIC_SELL_ZONE}`
        });
        let value = 0;

        const itemsList = items.map((item: Product, index: number) => {
            const { categories, code, grossPrice, grossPriceBeforeDiscount, title } = item;
            const numberGrossPrice = Number(grossPrice?.replace(',', '.'));
            const numberGrossPriceBeforeDiscount = Number(
                grossPriceBeforeDiscount?.replace(',', '.')
            );
            const discount = Math.round(
                numberGrossPriceBeforeDiscount * 100 - numberGrossPrice * 100
            );
            const category = categories?.[0].name || '';

            value += numberGrossPrice * 100;

            return {
                item_id: code,
                item_name: title,
                index: index + 1,
                discount: discount / 100,
                item_brand: brand,
                item_category: category,
                price: numberGrossPrice,
                quantity: 1
            };
        });

        window.dataLayer.push({ ecommerce: 'null' });
        window.dataLayer.push({
            event: 'view_item_list',
            ecommerce: {
                currency: currency,
                value: value / 100,
                items: itemsList
            }
        });
    }, [items, intl]);

    const productCards = items.map((item, index) => {
        return (
            <Box as={ListItem} key={index}>
                <ProductCard
                    code={item.code}
                    slug={item.slug}
                    categories={item.categories}
                    currency={item.currency}
                    discount={item.discount}
                    grossPrice={item.grossPrice}
                    grossPriceBeforeDiscount={item.grossPriceBeforeDiscount}
                    lowestPriceIn30Days={item.lowestPriceIn30Days}
                    isNew={item.new}
                    mainImage={item.mainImage}
                    maximalProductCountInOrder={item.maximalProductCountInOrder}
                    netPrice={item.netPrice}
                    netPromoPrice={item.netPromoPrice}
                    netUnitPrice={item.netUnitPrice}
                    notAvailableMessage={item.notAvailableMessage}
                    points={item.points}
                    productAvailableForSale={item.productAvailableForSale}
                    sale={item.sale}
                    title={item.title}
                    unit={item.unit}
                    subscribed={item.subscribed}
                    favourite={item.favourite}
                    removeFromFavourite={props.removeFromFavourite}
                />
            </Box>
        );
    });

    const productCardsUnlogged = items.map((item, index) => {
        return (
            <Box as={ListItem} key={index}>
                <ProductCardUnlogged
                    code={item.code}
                    slug={item.slug}
                    categories={item.categories}
                    currency={item.currency}
                    discount={item.discount}
                    grossPrice={item.grossPrice}
                    grossPriceBeforeDiscount={item.grossPriceBeforeDiscount}
                    lowestPriceIn30Days={item.lowestPriceIn30Days}
                    isNew={item.new}
                    mainImage={item.mainImage}
                    maximalProductCountInOrder={item.maximalProductCountInOrder}
                    netPrice={item.netPrice}
                    netPromoPrice={item.netPromoPrice}
                    netUnitPrice={item.netUnitPrice}
                    points={item.points}
                    productAvailableForSale={item.productAvailableForSale}
                    sale={item.sale}
                    title={item.title}
                    unit={item.unit}
                    subscribed={item.subscribed}
                    favourite={item.favourite}
                    removeFromFavourite={props.removeFromFavourite}
                />
            </Box>
        );
    });

    return (
        <SimpleGrid as={List} columns={{ base: 1, xl: 5, md: 3, sm: 2 }} gap={12}>
            {session.status === 'authenticated' ? productCards : productCardsUnlogged}
        </SimpleGrid>
    );
};
